var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOwl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1348_30090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9997 7.49609C56.4536 7.49609 69.7903 22.9715 69.7903 42.0484C69.7903 61.1354 56.4536 76.6008 39.9997 76.6008C23.5457 76.6008 10.209 61.1354 10.209 42.0484C10.209 22.9715 23.5457 7.49609 39.9997 7.49609Z",
    fill: "#F7CB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6124 55.2845H13.3867L39.9996 18.8457L66.6124 55.2845Z",
    fill: "#F7CB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.086 65.291L55.062 70.9707L50.0381 65.291L55.062 59.6113L60.086 65.291Z",
    fill: "#FBE5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9997 65.291L34.9758 70.9707L29.9619 65.291L34.9758 59.6113L39.9997 65.291Z",
    fill: "#FBE5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.962 65.291L24.938 70.9707L19.9141 65.291L24.938 59.6113L29.962 65.291Z",
    fill: "#FBE5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0378 65.291L45.024 70.9707L40 65.291L45.024 59.6113L50.0378 65.291Z",
    fill: "#FBE5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0622 59.6113L50.0383 65.291L45.0244 59.6113L50.0383 53.9316L55.0622 59.6113Z",
    fill: "#F7CB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1094 59.6113L60.0855 65.291L55.0615 59.6113L60.0855 53.9316L65.1094 59.6113Z",
    fill: "#F7CB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9763 59.6113L29.9624 65.291L24.9385 59.6113L29.9624 53.9316L34.9763 59.6113Z",
    fill: "#F7CB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9385 59.6113L19.9146 65.291L14.8906 59.6113L19.9146 53.9316L24.9385 59.6113Z",
    fill: "#F7CB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0235 59.6113L39.9995 65.291L34.9756 59.6113L39.9995 53.9316L45.0235 59.6113Z",
    fill: "#F7CB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.086 53.9317L55.062 59.6114L50.0381 53.9317L55.062 48.252L60.086 53.9317Z",
    fill: "#FBE5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9997 53.9317L34.9758 59.6114L29.9619 53.9317L34.9758 48.252L39.9997 53.9317Z",
    fill: "#FBE5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.962 53.9317L24.938 59.6114L19.9141 53.9317L24.938 48.252L29.962 53.9317Z",
    fill: "#FBE5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0378 53.9317L45.024 59.6114L40 53.9317L45.024 48.252L50.0378 53.9317Z",
    fill: "#FBE5BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71906 37.2871C6.71906 37.2871 4.66105 59.9554 21.4984 69.9529C26.9662 73.2013 18.1693 65.1812 20.4492 45.3678L6.71906 37.2871Z",
    fill: "#756D6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2808 37.2871C73.2808 37.2871 75.3388 59.9554 58.5015 69.9529C53.0337 73.2013 61.8306 65.1812 59.5507 45.3678L73.2808 37.2871Z",
    fill: "#756D6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9998 0C30.5976 9.34174 20.0049 1.17024 20.0049 1.17024C26.4715 12.8625 39.9998 15.0013 39.9998 15.0013C39.9998 15.0013 53.5282 12.8625 59.9948 1.17024C59.9948 1.17024 49.4021 9.34174 39.9998 0Z",
    fill: "#3E3435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3556 49.8558C10.0277 49.8558 0 39.828 0 27.5001C0 15.1723 10.0277 5.14453 22.3556 5.14453C34.6835 5.14453 44.7112 15.1723 44.7112 27.5001C44.7011 39.828 34.6835 49.8558 22.3556 49.8558Z",
    fill: "#3E3435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6447 49.8558C69.9913 49.8558 80.0003 39.8468 80.0003 27.5001C80.0003 15.1535 69.9913 5.14453 57.6447 5.14453C45.298 5.14453 35.2891 15.1535 35.2891 27.5001C35.2891 39.8468 45.298 49.8558 57.6447 49.8558Z",
    fill: "#3E3435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8785 39.8745C76.7138 33.0392 76.7138 21.9569 69.8785 15.1216C63.0431 8.28623 51.9608 8.28623 45.1255 15.1216C38.2902 21.9569 38.2902 33.0392 45.1255 39.8745C51.9608 46.7099 63.0431 46.7099 69.8785 39.8745Z",
    fill: "#F7CB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5033 15.002C64.4037 15.002 70.0026 20.6009 70.0026 27.5013C70.0026 34.4017 64.4037 40.0007 57.5033 40.0007C50.6029 40.0007 45.0039 34.4017 45.0039 27.5013C45.0039 20.6009 50.5928 15.002 57.5033 15.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5034 19.9941C61.6497 19.9941 65.0091 23.3535 65.0091 27.4897C65.0091 31.636 61.6497 34.9853 57.5034 34.9853C53.3571 34.9853 50.0078 31.6259 50.0078 27.4897C49.9977 23.3535 53.3571 19.9941 57.5034 19.9941Z",
    fill: "#302322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6259 9.99754C40.6259 14.1337 40.0005 17.4931 40.0005 17.4931C40.0005 17.4931 39.375 14.1337 39.375 9.99754C39.375 5.86135 40.0005 2.50195 40.0005 2.50195C40.0005 2.50195 40.6259 5.86135 40.6259 9.99754Z",
    fill: "#F7CB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9835 11.0559C38.3655 13.8201 38.7489 16.2514 38.7489 16.2514C38.7489 16.2514 36.8927 14.2035 35.5106 11.4494C34.1285 8.69527 33.7451 6.25391 33.7451 6.25391C33.7451 6.25391 35.6014 8.29174 36.9835 11.0559Z",
    fill: "#F7CB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0164 11.0559C41.6343 13.8201 41.251 16.2514 41.251 16.2514C41.251 16.2514 43.1072 14.2035 44.4893 11.4494C45.8714 8.69527 46.2548 6.25391 46.2548 6.25391C46.2548 6.25391 44.3985 8.29174 43.0164 11.0559Z",
    fill: "#F7CB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.497 9.99805C32.1615 9.99805 40.0001 17.8366 40.0001 27.5012C40.0001 37.1658 32.1615 45.0043 22.497 45.0043C12.8324 45.0043 5.00391 37.1658 5.00391 27.5012C5.00391 17.8366 12.8324 9.99805 22.497 9.99805Z",
    fill: "#F7CB80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4964 15.002C29.3968 15.002 34.9958 20.6009 34.9958 27.5013C34.9958 34.4017 29.3968 40.0007 22.4964 40.0007C15.5961 40.0007 9.99707 34.4017 9.99707 27.5013C9.99707 20.6009 15.5961 15.002 22.4964 15.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4966 19.9941C26.6428 19.9941 29.9921 23.3535 29.9921 27.4897C29.9921 31.636 26.6328 34.9853 22.4966 34.9853C18.3503 34.9853 15.001 31.6259 15.001 27.4897C15.001 23.3535 18.3604 19.9941 22.4966 19.9941Z",
    fill: "#302322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9453 38.7496C34.9453 43.0472 36.9125 46.8908 39.9995 49.423C43.0865 46.8908 45.0538 43.0573 45.0538 38.7496C45.0538 34.452 43.0865 30.6083 39.9995 28.0762C36.9125 30.6083 34.9453 34.452 34.9453 38.7496Z",
    fill: "#FDCD34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 28.0762V49.423C43.087 46.8908 45.0542 43.0573 45.0542 38.7496C45.0542 34.452 43.087 30.6083 40 28.0762Z",
    fill: "#F3B202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3354 70.4666C22.3354 73.7554 19.6721 78.6583 19.6721 78.6583C19.6721 78.6583 17.0088 73.7554 17.0088 70.4666C17.0088 67.1778 22.3354 67.1778 22.3354 70.4666Z",
    fill: "#F3B202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2534 70.4666C31.2534 73.7554 28.5901 78.6583 28.5901 78.6583C28.5901 78.6583 25.9268 73.7554 25.9268 70.4666C25.9167 67.1778 31.2534 67.1778 31.2534 70.4666Z",
    fill: "#F3B202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7944 69.7511C26.7944 73.8671 24.1311 80.0008 24.1311 80.0008C24.1311 80.0008 21.4678 73.8671 21.4678 69.7511C21.4577 65.6351 26.7944 65.6351 26.7944 69.7511Z",
    fill: "#F3B202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0835 70.4666C54.0835 73.7554 51.4202 78.6583 51.4202 78.6583C51.4202 78.6583 48.7569 73.7554 48.7569 70.4666C48.7468 67.1778 54.0835 67.1778 54.0835 70.4666Z",
    fill: "#F3B202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9917 70.4666C62.9917 73.7554 60.3283 78.6583 60.3283 78.6583C60.3283 78.6583 57.665 73.7554 57.665 70.4666C57.665 67.1778 62.9917 67.1778 62.9917 70.4666Z",
    fill: "#F3B202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5317 69.7511C58.5317 73.8671 55.8684 80.0008 55.8684 80.0008C55.8684 80.0008 53.2051 73.8671 53.2051 69.7511C53.2051 65.6351 58.5317 65.6351 58.5317 69.7511Z",
    fill: "#F3B202"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1348_30090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwl);
export default __webpack_public_path__ + "static/media/owl.133744c24bde3cae0934a34a225102e9.svg";
export { ForwardRef as ReactComponent };